(function ($) {
  if($('.dol-accordion').length > 0) {
    var pathname = btoa(window.location.pathname);
    function pageLoad () {
      var accordionVal = JSON.parse(localStorage.getItem('Open Accordions'));
      var hash = window.location.hash.substr(1);

      styleAccordion();

      // checks if we have a hash in the url
      if (window.location.hash) {
        var idArray = $(".paragraph--type--accordion-item #" + hash).parents('.usa-accordion');
        setAccordions(idArray, true, false);
      }
      // checks if local storage is set for this page already
      else if (accordionVal && Object.prototype.hasOwnProperty.call(accordionVal, pathname)) {
        // This variable contains an array of the ids of the accordions that were left open
        var openIds = accordionVal[pathname];
        // For each id of an accordion that was left open, give it a class of show which would open it back up
        for (var i = 0; i < openIds.length; i++) {
          var idArray = $(".paragraph--type--accordion-item #" + openIds[i]);
          setAccordions(idArray, true, false);
        }
        if (!openIds.length) {
          auditAccordionToggle();
        }
      }
      // check to run initial logic of setting first accordion
      else {
        $('.paragraph--type--row .field--name-field-bundles').each(function () {
          var firstAccordion = $(this).find('.paragraph--type--accordion-item').first().find('.usa-accordion');
          setAccordions(firstAccordion, true, false);
        });
      }
    }

    // checks status of each accordion block to show expand and collapse states.
    function auditAccordionToggle () {
      $(".field--name-field-bundles, .ilab-collapsible-sections, .ilab-findings-region, .ilab-resources").each(function ilabAccordionPanelToggle() {
        var accordionList = $(this).find(".accordion-group").find('.usa-accordion__content');
        var openList = accordionList.filter( function(curr, index) {
          return !index.hasAttribute('hidden');
        });
        if (!$(this).find(".accordion-group .panel-toggler").length) {
          $(this).find(".accordion-group").first().prepend('<div class="panel-toggler"><a href="#" class="expand-all">Expand All</a><span class="accordionExpColDivider">&nbsp;|&nbsp;</span><a href="#" class="collapse-all">Collapse All</a></div>');
        }
        if (openList.length === accordionList.length) {
          $(this).find(".expand-all, .accordionExpColDivider").css('display', 'none');
          $(this).find(".collapse-all").css('display', 'inline');
        } else if (!openList.length) {
          $(this).find(".expand-all").css('display', 'inline');
          $(this).find(".collapse-all, .accordionExpColDivider").css('display', 'none');
        } else {
          $(this).find(".expand-all, .accordionExpColDivider, .collapse-all").css('display', 'inline');
        }
      });
    }

    // this function styles the accordions and wraps each accordion group on a page to it's own div
    function styleAccordion () {
      var accordionKnt = 1;
      var accordionGroup = 0;
      $(".dol-accordion").each(function accordionBuilder() {
        accordionGroup += 1;
        $(this)
          .parent()
          .addClass("accordion-group accordion-group-" + accordionGroup);
        var accordionMainId = "dolAccordion" + accordionKnt;
        $(this).addClass(accordionMainId);
        accordionKnt += 1;
      });

      $('.paragraph--type--row .field--name-field-bundles, .ilab-resources, .ilab-collapsible-sections .field--name-field-collapsible-section-').each(function () {
        $(this).children('.accordion-group').wrapAll("<div class='accordion-wrapper' style='flex: 0 0 100%'></div>");
      });
    }

    // function to set accordion states
    // first parameter is an array of accordions to set
    // second parameter is the state to set the accordion (open or close)
    // the third parameter is a boolean to show if the uswds accordion functionality is being used
    function setAccordions (accordionIds, openState, uswdsClick) {
      var accordionVal = JSON.parse(localStorage.getItem('Open Accordions'));

      if (accordionVal == null || accordionVal.length == 0 || typeof accordionVal == undefined) {
        accordionVal = {};
      }
      var elements = [];

      setTimeout(function(){
        $(".paragraph--type--accordion-item .usa-accordion__content").not("[hidden]").each(function() {
          var id = $(this).parent().attr("id");
          elements.push(id);
        });
        // Assign the current hashed page url as the key and the open accordion ids as the value
        accordionVal[pathname] = elements;
        localStorage.setItem('Open Accordions', JSON.stringify(accordionVal));
        auditAccordionToggle();
      }, 200);

      accordionIds.each(function () {
        var element = $(this);
        if (openState) {
          if(!uswdsClick) {
            element.find("button").attr('aria-expanded', 'true');
            element.find(".usa-accordion__content").removeAttr('hidden');
          }
          // this checks for if font awsome has loaded yet...
          if (element.find('i.fa').length === 1) {
            element.find('i.fa').toggleClass('fa-angle-right fa-angle-down');
          } else {
            // on load there are a few cases where the class gets changed but the svg does not so we explicity do that below...
            element.find('svg path').attr('d', 'M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z');
            element.find('svg').toggleClass('fa-angle-right fa-angle-down').attr('data-icon','angle-down');
          }
        }
        else {
          if(!uswdsClick) {
            element.find("button").attr('aria-expanded', 'false');
            element.find(".usa-accordion__content").attr('hidden', '');
          }
          // this checks for if font awsome has loaded yet...
          if (element.find('i.fa').length === 1) {
            element.find('i.fa').toggleClass('fa-angle-down fa-angle-right');
          } else {
            // on load there are a few cases where the class gets changed but the svg does not so we explicity do that below...
            element.find('svg path').attr('d', 'M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z');
            element.find('svg').toggleClass('fa-angle-down fa-angle-right').attr('data-icon','angle-right');
          }
        }
      });
    }

    pageLoad();

    $('.accordion-wrapper').on('click', function (e) {
      // single accordion click
      if ($(e.target).parents('.usa-accordion__heading').length) {
        var idElement = $(e.target).parents('.usa-accordion');
        var state = idElement.find("button").attr('aria-expanded');
        // reverses the value and changes type from a string to boolean
        var stateSwitch = !(state == "true");
        setAccordions(idElement,stateSwitch,true);
      }
      // expand all
      if ($(e.target).hasClass('expand-all')) {
        e.preventDefault();
        var expandAll = $(this).find('.usa-accordion');
        setAccordions(expandAll,true,false);
        $(this).find('svg path').attr('d', 'M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z');
        $(this).find('svg').removeClass('fa-angle-right').addClass('fa-angle-down').attr('data-icon','angle-down');
      }
      // collapse all
      if ($(e.target).hasClass('collapse-all')) {
        e.preventDefault();
        var collapseAll = $(this).find('.usa-accordion');
        setAccordions(collapseAll,false,false);
        $(this).find('svg path').attr('d', 'M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z');
       $(this).find('svg').removeClass('fa-angle-down').addClass('fa-angle-right').attr('data-icon','angle-right');
      }
    });

    //In-Page Quick Link Event Assignment
    $(".accordion-expand").on('click', function(e) {
      var idElement = $(e.target.hash);
      setAccordions(idElement,true,false);
    });
  }
})(jQuery);
